import _typeof from '@babel/runtime/helpers/typeof';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import classNames from 'classnames';
import * as React from 'react';
import { A11YLabel } from '../A11YLabel/A11YLabel.js';
import { StyledButton } from './StyledButton.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["active", "aria-disabled", "as", "children", "className", "disabled", "elevated", "endAdornment", "hideLabel", "iconSize", "label", "startAdornment", "tabIndex", "type", "variant", "onClick"];
var Button = /*#__PURE__*/React.forwardRef(function Button2(props, ref) {
  var active = props.active,
      ariaDisabledBooleanish = props["aria-disabled"],
      as = props.as,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      elevated = props.elevated,
      endAdornment = props.endAdornment,
      hideLabel = props.hideLabel,
      iconSize = props.iconSize,
      label = props.label,
      startAdornment = props.startAdornment,
      tabIndex = props.tabIndex,
      type = props.type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? "secondary" : _props$variant,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, _excluded);

  var ariaDisabled = ariaDisabledBooleanish === void 0 ? void 0 : (ariaDisabledBooleanish === null || ariaDisabledBooleanish === void 0 ? void 0 : ariaDisabledBooleanish.toString()) === "true";
  var classes = classNames("mntlui-".concat(variant), className, {
    "mntlui-active": disabled ? false : active,
    "mntlui-disabled": disabled || ariaDisabled,
    "mntlui-elevated": elevated,
    "mntlui-hideLabel": hideLabel
  });
  return /*#__PURE__*/jsx(StyledButton, _objectSpread(_objectSpread({
    "aria-disabled": ariaDisabled,
    variant: variant,
    "aria-label": hideLabel ? label : void 0,
    as: as,
    className: classes,
    disabled: disabled,
    ref: ref,
    tabIndex: disabled ? -1 : tabIndex,
    type: as ? void 0 : type || "button",
    onClick: ariaDisabled || onClick ? function (e) {
      if (onClick && !ariaDisabled) onClick(e);
    } : void 0
  }, rest), {}, {
    children: children ? /*#__PURE__*/jsx("span", {
      style: disabled ? {
        pointerEvents: "none"
      } : void 0,
      children: children
    }) : /*#__PURE__*/jsx(A11YLabel, {
      endAdornment: endAdornment,
      hideLabel: hideLabel,
      iconSize: iconSize,
      label: label,
      startAdornment: startAdornment
    })
  }));
});
Button.propTypes = {
  "active": _PropTypes.bool,
  "aria-disabled": _PropTypes.oneOfType([_PropTypes.oneOf(["false", "true"]), _PropTypes.bool]),
  "as": _PropTypes.oneOfType([_PropTypes.string, _PropTypes.func, _PropTypes.object]),
  "children": _PropTypes.node,
  "className": _PropTypes.string,
  "disabled": _PropTypes.bool,
  "elevated": _PropTypes.bool,
  "endAdornment": function checkAdornment(props, propName, componentName) {
    var isReactNodeType = function isReactNodeType(el) {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for ? Symbol.for('react.element') : 0xeac7;
      var isValidElement = _typeof(el) === 'object' && el !== null && el['\$\$typeof'] === REACT_ELEMENT_TYPE;
      return el === undefined || el === null || typeof el === 'boolean' || typeof el === 'string' || isValidElement;
    };

    var adornment = (propName === 'startAdornment' || propName === 'endAdornment') && props[propName];

    if (!isReactNodeType(adornment)) {
      var name = adornment.displayName || adornment.name || 'Component';

      if (!(name.indexOf('Icon') === 0)) {
        return new Error("Invalid prop \"" + propName + "\". Invalid React component with name \"" + name + "\" was supplied to \"" + componentName + "\". Only Icon components are allowed.\n");
      }
    }
  },
  "hideLabel": _PropTypes.bool,
  "iconSize": _PropTypes.oneOf([16, 20, 24, 32]),
  "label": _PropTypes.string.isRequired,
  "onClick": _PropTypes.func,
  "startAdornment": function checkAdornment(props, propName, componentName) {
    var isReactNodeType = function isReactNodeType(el) {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for ? Symbol.for('react.element') : 0xeac7;
      var isValidElement = _typeof(el) === 'object' && el !== null && el['\$\$typeof'] === REACT_ELEMENT_TYPE;
      return el === undefined || el === null || typeof el === 'boolean' || typeof el === 'string' || isValidElement;
    };

    var adornment = (propName === 'startAdornment' || propName === 'endAdornment') && props[propName];

    if (!isReactNodeType(adornment)) {
      var name = adornment.displayName || adornment.name || 'Component';

      if (!(name.indexOf('Icon') === 0)) {
        return new Error("Invalid prop \"" + propName + "\". Invalid React component with name \"" + name + "\" was supplied to \"" + componentName + "\". Only Icon components are allowed.\n");
      }
    }
  },
  "tabIndex": _PropTypes.number,
  "type": _PropTypes.oneOf(["button", "reset", "submit"]),
  "variant": _PropTypes.oneOf(["ghost", "primary", "secondary", "tertiary", "warning"])
};
Button.displayName = "Button";

export { Button };
